import { Typography } from '@mui/material'
import React from 'react'

import { Checkbox } from '@/app/component/atom/form'
import ActionsBox from '@/app/module/campaigns/component/actions/actions-box'
import { SMS_ACTION_DEFAULT_SENDERID } from '@/app/module/campaigns/definitions'
import { CampaignTemplateType, LocalAction, LocalOnInvalidReply, PartFamily } from '@/app/module/campaigns/types'
import { getActionOptionsForCampaign } from '@/app/module/campaigns/utils/actions/options'
import { ActionContext } from '@/app/module/campaigns/utils/actions/types'
import { ChangeEvent } from '@/app/types'

import { ActionProps, ApiProps } from './part-config-props'
import { ActionsBoxContainer } from './response-configs-components'

type Props = {
  actionProps: ActionProps
  apiProps: ApiProps
  campaignType: CampaignTemplateType
  id: string
  info: string
  invalid: LocalOnInvalidReply

  onChange: (value: Partial<LocalOnInvalidReply>) => void
}

const ResponseVoiceInvalid: React.FC<Props> = ({
  actionProps,
  apiProps,
  campaignType,
  id,
  info,
  invalid,
  onChange,
}) => {
  const actionOptions = React.useMemo(
    () =>
      getActionOptionsForCampaign({
        campaignType,
        partType: PartFamily.Voice,
        actionNamespace: ActionContext.OnInvalid,
      }),
    [campaignType],
  )

  const handleToggle = React.useCallback(
    ({ value }: ChangeEvent<string>) => {
      const isEnabled = value === 'true'
      onChange({
        actions: [],
        enabled: isEnabled,
      })
    },
    [onChange],
  )
  const handleActionsChange = React.useCallback(
    (actions: LocalAction[]) =>
      onChange({
        actions,
      }),
    [onChange],
  )

  return (
    <div className="campaign-question-invalid-box">
      <Checkbox
        editable
        label="Invalid keypress"
        name="invalid-keypress"
        value={(invalid.enabled || false).toString()}
        onChange={handleToggle}
      />
      <ActionsBoxContainer>
        <Typography color="textSecondary" gutterBottom variant="caption">
          {info}
        </Typography>
        {invalid.enabled && (
          <ActionsBox
            {...actionProps}
            {...apiProps}
            actionOptions={actionOptions}
            actions={invalid.actions}
            defaultSenderId={SMS_ACTION_DEFAULT_SENDERID.voiceQuestion}
            hasTranscribe={false}
            transcribeEnabled={false}
            updateContactConfig={updateContactConfig}
            voiceId={`${id}-invalid`}
            onChange={handleActionsChange}
          />
        )}
      </ActionsBoxContainer>
    </div>
  )
}

const updateContactConfig = {
  invalid: true,
  question: false,
  openResponse: false,
}

export default React.memo(ResponseVoiceInvalid)
